const Products = () => {
  return (
    <div>
      <div className="center-greetings">
        <h1>제품소개</h1>
        <hr></hr>
      </div>
      <div style={{ marginTop: "50px" }}>
        <div style={{ textAlign: "left" }}>
          <h2>- 몽페스트</h2>
        </div>
        <img
          alt="product"
          style={{ width: "100%" }}
          src="/img/product1.jpg"
        ></img>
        <div style={{ textAlign: "left" }}>
          <h2>- 석수</h2>
        </div>
        <img
          alt="product"
          style={{ width: "100%" }}
          src="/img/product2.jpg"
        ></img>
        <div style={{ textAlign: "left" }}>
          <h2>- 삼다수</h2>
        </div>
        <img
          alt="product"
          style={{ width: "100%" }}
          src="/img/product3.png"
        ></img>
        <div style={{ textAlign: "left" }}>
          <h2>- 아이시스</h2>
        </div>
        <img
          alt="product"
          style={{ width: "100%" }}
          src="/img/product4.jpg"
        ></img>
      </div>
    </div>
  );
};

export default Products;
